import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import {
  useRetrieveCurrentPlanzone,
  useRetrieveProjectExpenseTypes,
  useCreateProjectExpenseType,
} from "@planzone/view-models";
import { SelectList } from "@common/selectList";
import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";
import { projectExpenseType } from "@planzone/dto";
import { ExpenseTypeIcon } from "./expenseTypeIcon";
import { ExpenseTypeCreation } from "./expenseTypeCreation";
import { Props } from "./types";
import styles from "./styles.scss";

function ExpenseTypeSelect({ formData, edit }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { projectExpenseTypes, retrieveProjectExpenseTypes } =
    useRetrieveProjectExpenseTypes();
  const { isRequestPending, createProjectExpenseType } =
    useCreateProjectExpenseType();

  React.useEffect(() => {
    retrieveProjectExpenseTypes();
  }, []);

  return (
    <SelectList rootClassName={styles.root} listClassName={styles.listRoot}>
      {({ isOpen, select }) => ({
        input: (
          <div
            className={classNames(styles.input, {
              [styles.opened]: isOpen,
            })}
          >
            {!!formData.expenseType.name && (
              <ExpenseTypeIcon
                deletable
                expenseType={formData.expenseType}
                onClick={() =>
                  edit({ ...formData, expenseType: projectExpenseType })
                }
              />
            )}
            {!formData.expenseType.name && (
              <div>
                {t("projectBudgetSynthesis.expenses.edition.expenseType")}
              </div>
            )}
            <ToggleArrowIcon className={styles.icon} />
          </div>
        ),
        list: (
          <div className={styles.list}>
            {projectExpenseTypes.map((projectExpenseType) => (
              <ExpenseTypeIcon
                expenseType={projectExpenseType}
                onClick={() => {
                  edit({ ...formData, expenseType: projectExpenseType });
                  select(projectExpenseType);
                }}
              />
            ))}
            <ExpenseTypeCreation
              submit={(value) =>
                !isRequestPending &&
                createProjectExpenseType({
                  planzone,
                  projectExpenseType: value,
                })
              }
            />
          </div>
        ),
      })}
    </SelectList>
  );
}

export { ExpenseTypeSelect };
